import { AutoComplete, DatePicker, Form, Input, Select } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search, select_id } from "../../../../Controllers/Global";
import moment from "moment";
import { get_employee } from "../../../../Controllers/Employees/Employees";
import Error from "../../../../Componets/Error";

const Projectjobemployeestable = React.forwardRef((props, focus) => {
  const {
    employeeDetails,
    setEmployeeDetails,
    employeeTotals,
    setEmployeeTotals,
  } = props;

  const handleSearch = async (e, index) => {
    let data = [...employeeDetails];

    const select = {
      api: "get-all-employees",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({ value: value?._id, label: value?.name });
      });

      data[index].options = options;

      setEmployeeDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleDescription = async (e, index) => {
    let data = [...employeeDetails];

    let params = {
      id: e,
    };
    const employee = await get_employee(params);

    if (employee?.status) {
      let description_ids = [];

      data?.map((v, i) => {
        description_ids?.push(v?.description);
      });

      if (description_ids?.includes(employee?.data?._id)) {
        let selected_index = description_ids?.indexOf(employee?.data?._id);

        focus.current[`hours${selected_index}`].current.focus();
      } else {
        let data_description = employee?.data?._id;
        let data_name = employee?.data?.name;
        let data_role = employee?.data?.role?.name;
        let data_hours = "";
        let data_charges = employee?.data?.charges;

        data[index].description = data_description;
        data[index].name = data_name;
        data[index].role = data_role;
        data[index].hours = data_hours;
        data[index].charges = data_charges;

        setEmployeeDetails(data);

        focus.current[`hours${index}`].current.focus();
      }
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key && e ? e : !key && e?.target?.value ? e?.target?.value : "";

    if (value >= 0) {
      let data = [...employeeDetails];

      let data_charges = data[index]?.charges ? data[index]?.charges : 0;
      let data_hours = data[index]?.hours ? data[index]?.hours : 0;

      let charges = name === "charges" ? value : data_charges;
      let hours = name === "hours" ? value : data_hours;

      let total = parseFloat(charges) * parseFloat(hours ? hours : 1);
      data[index][name] = value;
      data[index].total = total ? total?.toFixed(3) : 0;

      let subtotal = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total),
        0
      );

      let grandtotal = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total),
        0
      );

      employeeTotals.subtotal = subtotal;
      employeeTotals.total = grandtotal;

      setEmployeeDetails(data);
      setEmployeeTotals({ ...employeeTotals });
    }
  };

  const handleRemove = (index) => {
    let data = [...employeeDetails];

    data?.splice(index, 1);

    setEmployeeDetails(data);
  };

  const handleAdd = () => {
    setEmployeeDetails((prevemployeeDetails) => [
      ...prevemployeeDetails,
      {
        id: "",
        description: null,
        hours: "",
        charges: "",
        hours: "",
        total: 0,
      },
    ]);

    setTimeout(() => {
      focus.current[`description${employeeDetails?.length}`].current.focus();
    }, 200);
  };

  return (
    <div>
      <table className="w-full">
        <thead>
          <tr>
            <td className="border p-4 text-black">S.No</td>
            <td className="border p-4 text-black">Description</td>
            <td className="border p-4 text-black">Role</td>
            <td className="border p-4 text-black">Hours</td>
            <td className="border p-4 text-black">Charges</td>
            <td className="border p-4 text-black">Total</td>
            <td className="border p-4 text-black">Delete</td>
          </tr>
        </thead>
        <tbody>
          {employeeDetails?.map((value, index) => {
            focus.current[`description${index}`] = createRef();
            focus.current[`hours${index}`] = createRef();
            focus.current[`charges${index}`] = createRef();

            return (
              <React.Fragment>
                <tr>
                  <td className="border p-4 text-center">{index + 1}</td>
                  <td className="border p-4">
                    {value?.description ? (
                      <div>{value?.name}</div>
                    ) : (
                      <Select
                        key={index}
                        className="w-[250px] text-regular"
                        name="description"
                        placeholder="Description"
                        ref={focus.current[`description${index}`]}
                        allowClear={true}
                        showSearch={true}
                        filterOption={false}
                        options={value?.options}
                        value={value?.description}
                        onFocus={(e) => handleSearch("", index)}
                        onSearch={(e) => handleSearch(e, index)}
                        onClick={(e) => handleSearch("", index)}
                        onChange={(e) => handleDescription(e, index)}
                        autoComplete="off"
                      />
                    )}
                    <Error id={`description${index}`} />
                  </td>
                  <td className="border p-4 text-center">{value?.role}</td>
                  <td className="border p-4 text-center">
                    <Input
                      type="number"
                      className="w-full"
                      ref={focus.current[`hours${index}`]}
                      name="hours"
                      placeholder="Hours"
                      value={value?.hours}
                      onChange={(e) => handleTotal(e, index)}
                      autoComplete="off"
                    />
                    <Error id={`hours${index}`} />
                  </td>
                  <td className="border p-4 ">
                    <Input
                      type="number"
                      className="w-full"
                      ref={focus.current[`charges${index}`]}
                      name="charges"
                      placeholder="Charges"
                      value={value?.charges}
                      onChange={(e) => handleTotal(e, index)}
                      autoComplete="off"
                    />
                    <Error id={`charges${index}`} />
                  </td>
                  <td className="border p-4 text-center">
                    {parseFloat?.(value?.total)?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => handleRemove(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4 text-center" colSpan={2}>
              <AddButton onClick={handleAdd} />
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={4}></td>
            <td className="border p-4 text-black text-medium">Total</td>
            <td className="border p-4 text-black text-medium" colSpan={2}>
              {employeeTotals?.total > 0
                ? employeeTotals?.total?.toFixed(3)
                : "0.000"}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

export default Projectjobemployeestable;
